import { useState } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import "./Faq.css";

const faqData = [
    {
        question: "What is Whalesai.com?",
        answer:
            "Whalesai.com is an AI platform that helps you create content for your social media channels. It positions itself as the world’s first AI-based social media marketing manager, offering eleven AI tools for video, image, voice, and written content.",
    },
    {
        question: "Is Whalesai a subscription or pay-per-use?",
        answer:
            "Whalesai is pay-per-use. You buy credits and only pay for the content you generate, with no subscription fees or upfront costs.",
    },
    {
        question: "How much does Whalesai cost?",
        answer:
            "Whalesai offers three credit packages: USD 5 for 250 credits, USD 80 for 5,000 credits (20% off), and USD 600 for 50,000 credits (40% off). Individual tools cost from as little as USD 0.012 per use.",
    },
    {
        question: "What can I create with Whalesai?",
        answer:
            "You can create comic videos, news videos, text videos, photo posts, social posts, AI images, voiceovers, toy-style images, developer projects, and marketing consulting answers across eleven different AI tools.",
    },
    {
        question: "How many credits does each Whalesai tool use?",
        answer:
            "Costs vary by tool: Social Post AI (75 credits), Comic Video AI (45 credits per video), Developer AI (834 credits per project), News Video AI (35 credits), Text Video AI (35 credits), Image AI (10 credits), Post AI (10 credits), Toy Stories AI (10 credits), and Social Media Consultant, Text AI, and Voice AI (1 credit per 3,000 characters).",
    },
    {
        question: "How long does Whalesai store my generated content?",
        answer:
            "Whalesai stores generated content for 30 days only. You must download or save anything you want to keep before it expires.",
    },
    {
        question: "Do I need technical skills to use Whalesai?",
        answer:
            "No. Whalesai has a user-friendly interface that requires no advanced technical skills and is available 24/7, so anyone can generate content anytime.",
    },
    {
        question: "Does Whalesai have an affiliate program?",
        answer:
            "Yes. You can share your affiliate code or link to earn 5% of sales generated through you, and anyone who uses your code receives a 5% discount at Whalesai.com.",
    },
    {
        question: "What is Whalesai Voice AI?",
        answer:
            "Voice AI generates natural-sounding voiceovers from your text scripts using emotion detection. You can choose a voice type, and it costs 1 credit per 3,000 characters.",
    },
    {
        question: "Is AI-generated content from Whalesai accurate?",
        answer:
            "Whalesai notes that while its AI strives for accuracy, it may occasionally make mistakes. You should verify any important information before relying on it.",
    },
]

export default function Faq() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div>
            <PageHeading title="FAQ" />
            <section className="faq-section">
                <div className="faq-container">
                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? "active" : ""}`}
                            onClick={() => toggleFaq(index)}
                        >
                            <div className="faq-question">
                                <div style={{ display: "flex", alignItems: "flex-start" }}>
                                    <span className="faq-question-number">
                                        {index + 1}.
                                    </span>
                                    <p className="faq-question-text">
                                        {item.question}
                                    </p>
                                </div>
                                <span className="faq-toggle-icon">+</span>
                            </div>
                            <div className="faq-answer-wrapper">
                                <p className="faq-answer">{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}